module.exports = (__webpack_require__(20))(112);